export default "__VITE_ASSET__C9cE5$fR__"